import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M14.151 19.737C13.885 19.737 13.62 19.632 13.422 19.423C13.044 19.021 13.063 18.388 13.465 18.009L18.786 13.001H3.00098C2.44898 13.001 2.00098 12.553 2.00098 12.001C2.00098 11.449 2.44898 11.001 3.00098 11.001H18.788L13.466 5.99102C13.064 5.61302 13.045 4.98002 13.423 4.57702C13.804 4.17502 14.435 4.15602 14.837 4.53502L21.466 10.775C21.792 11.083 21.985 11.508 21.998 11.95C21.999 11.967 21.999 11.984 21.999 12.001C21.999 12.019 21.999 12.036 21.998 12.053C21.983 12.494 21.792 12.919 21.467 13.226L14.837 19.466C14.644 19.647 14.397 19.737 14.151 19.737V19.737Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ArrowRight');

export default Icon;
